import { BP42InitialState } from '~/src/packages/bp42/reducer/initialState';

const isNeedToShowResult = (state: BP42InitialState): boolean => state.needToShowResponseResult;

export default isNeedToShowResult;
